import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import "../User/SignUp.css";
import instance, { apiEncryptRequest, decryptData } from "../../Api";
import { useAuth } from "../../AuthContext";
import Loader from "../common/Loader";
import toast, { Toaster } from "react-hot-toast";
import AppToast from "../../AppToast";

const EmailVerification = (props) => {
  const { isMobile } = props;
  const { updateUserDetails, updateCurrencyRate, updateAppCurrency } = useAuth();
  const { smuser } = useAuth();

  const [emailOTP, setemailOTP]     = useState("");
  const [phoneOTP, setPhoneOTP]     = useState("");
  const [phone, setPhone]           = useState("");
  const [email, setEmail]           = useState("");
  const [loading, setLoading]       = useState(false);
  const [showEmail, setShowEmail]   = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(true);
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);

  useEffect(() => {
    if (smuser) {
      setEmail(smuser.email);
      if (smuser.emailverify !== 1) {
        setShowEmail(true);
      } else {
        window.location.href = "/vm/create";
      }
    }
  }, [smuser]);

  const ChangeCurrency = async () => {
    const payload = { country: smuser.prefer_currency, user_id: smuser.id };
    try {
      const res = await instance.post("/changescurrency", payload);
      updateCurrencyRate(res.data.currency1);
      updateCurrencyRate(res.data.native_credit);
      updateUserDetails(res.data.response);
      const key = smuser.prefer_currency === "EUR" ? `cu_EURO` : `cu_${smuser.prefer_currency}`;
      updateAppCurrency(res.data.currency1[key]);
    } catch (error) {
      console.error("Error during the login process:", error);
    }
  };

  // Shared logic for EmailVerifyCall and resendEmailVerifyCall.
  // requireOtp=true shows a "Please enter OTP" guard (used by the submit button).
  const callEmailOtp = async (requireOtp = false) => {
    setLoading(true);
    if (requireOtp && emailOTP === "") {
      toast((t) => <AppToast id={t.id} message="Please enter OTP" isMobile={isMobile} />);
      setLoading(false);
      return;
    }
    const payload = { user_id: smuser.id, email, otp: emailOTP };
    try {
      const enc = await apiEncryptRequest(payload);
      const res = await instance.post("/getemailotp", enc);
      const data = await decryptData(res.data);

      if (emailOtpSent) {
        if (data.status) {
          ChangeCurrency();
          toast((t) => <AppToast id={t.id} message={data.message} />);
          window.location.href = "/vm/create";
        } else {
          if (requireOtp) toast((t) => <AppToast id={t.id} message={data.message} />);
        }
      } else {
        if (data.status) {
          setEmailOtpSent(true);
          toast((t) => <AppToast id={t.id} message={data.message} />);
        }
      }
    } catch (error) {
      console.error("Error during the login process:", error);
      if (requireOtp) toast((t) => <AppToast id={t.id} message={error} />);
    }
    setLoading(false);
  };

  const EmailVerifyCall       = () => callEmailOtp(true);
  const resendEmailVerifyCall = () => callEmailOtp(false);

  const PhoneVerifyCall = async () => {
    setLoading(true);
    if (phone !== "") {
      const payload = { user_id: smuser.id, phone, otp: phoneOTP, name: smuser.name };
      try {
        const enc = await apiEncryptRequest(payload);
        const res = await instance.post("/getmobileotp", enc);
        const data = await decryptData(res.data);
        if (phoneOtpSent) {
          if (data.status) {
            toast((t) => <AppToast id={t.id} message={res.data.message} isMobile={isMobile} />);
            window.location.href = "/vm/create";
          }
        } else {
          console.log(data);
          if (data.status) setPhoneOtpSent(true);
        }
      } catch (error) {
        console.error("Error during the login process:", error);
      }
    } else {
      toast((t) => <AppToast id={t.id} message="All fields are required!" isMobile={isMobile} />);
    }
    setLoading(false);
  };

  // ── Email form — shared between mobile and web (minor layout diff handled by `web` prop)
  const EmailForm = ({ web }) => (
    showEmail ? (
      <>
        <h5 style={{ fontSize:"24px", color:"white", fontWeight:"500", textAlign:"center", marginBottom:"20px" }}>
          Enter OTP to verify your account. OTP sent to registred email.
        </h5>
        <form className="see-full">
          <input type="hidden" name="_token" value="IHks1cEdGGmsvouWsdVeWVHE29KFoaLV0iN8cPkE" />
          <div className="form-top">
            <div className="input-container" style={{ marginTop:"15px" }}>
              <img src="/images/email.svg" alt="" className="imgIcon-signup" />
              <input type="text" id="password-field" className="input-signup" name="email" placeholder="Enter email" value={email} disabled="true" onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>
          {emailOtpSent && (
            <div style={{ display:"grid", justifyItems:"center" }}>
              <div className="input-container" style={{ marginTop:"15px" }}>
                <input maxLength={6} type="number" id="otp-field" className="input-signup" name="otp" placeholder="OTP"
                  value={emailOTP} onChange={(e) => setemailOTP(e.target.value)}
                  style={{ textAlign:"center", border:"none", borderRadius:"0", padding:"0 0 0 7px" }} />
              </div>
            </div>
          )}
          <div style={{ display:"grid", justifyItems:"center" }}>
            <div className="log-in" style={web ? { marginTop:"20px", marginBottom:"20px" } : undefined} onClick={EmailVerifyCall}>
              <a className="media-link">
                <div className="media-banner" style={{ width:"auto", height:"50px", marginTop:"10px" }}>
                  <img className="normal-banner" src="/images/signup-btn-bg.png" alt="" />
                  <img className="hover-img-banner" src="/images/search-btn-hover.png" alt="/images/search-btn-hover.png" />
                  <span className="login-text" style={{ fontSize:"20px", color:"#07528B", marginTop:"0px" }}>{"Verify OTP"}</span>
                </div>
              </a>
            </div>
          </div>
        </form>
        <div className="btm desk">
          <span className="rgst mob">Not Received OTP? </span>
          <a onClick={resendEmailVerifyCall}>Click Here</a>
        </div>
      </>
    ) : null
  );

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <div>
      <div className="apptoast-align">
        <Toaster position={isMobile ? "top-center" : "bottom-right"} reverseOrder={false} />
      </div>

      {isMobile ? (
        <div style={{ marginLeft:"10px", marginRight:"10px" }}>
          <div className="register-main see-full" style={{ marginTop:"8rem" }}>
            <div className="bg-img">
              <img src="/images/blue-box-bg.svg" alt="" style={{ width:"auto", height:"300px" }} />
            </div>
            <EmailForm />
          </div>
        </div>
      ) : (
        <div style={{ width:"100%", minHeight:"65rem", position:"relative", backgroundImage:"url(/main-bg.jpg)", backgroundSize:"cover", backgroundRepeat:"round", backgroundBlendMode:"overlay" }}>
          <Row>
            <div className="col-md-4" />
            <div className="col-md-4">
              <div className="register-main see-full" style={{ marginTop:"8rem" }}>
                <div className="bg-img">
                  <img src="/images/blue-box-bg.svg" alt="" style={{ marginLeft:"15%", width:"65%", padding:"4%" }} />
                </div>
                <EmailForm web />
              </div>
            </div>
            <div className="col-md-4" />
          </Row>
        </div>
      )}

      {loading && (
        <div className="loading-overlay" style={{ zIndex:"9999999999999999" }}>
          <Loader isLoading={loading} />
        </div>
      )}
    </div>
  );
};

export default EmailVerification;